module.exports = __webpack_public_path__ + "media/assets/images/flags/mx-c31d003fbd336bf6871406f31010cfb4.svg";